
import { Component, Mixins } from "vue-property-decorator";
import Prepaid from "@/interfaces/Contracts/Prepaid";
import {
  getPrepaidTransactions,
  getPrepaidSummaries,
} from "@/repositories/Contracts/PrepaidsRepository";
import PrepaidPurchaseSummary from "@/interfaces/Contracts/PrepaidPurchaseSummary";
import PrepaidTransaction from "@/interfaces/Contracts/PrepaidTransaction";
import CardListDetailDetailCardMixin from "@/mixins/CardListDetailDetailCardMixin";
import BaseDetailCard from "@/components/Base/CardListDetail/BaseDetailCard.vue";
import CardListDetailNavigationOptions from "@/interfaces/Base/CardListDetail/CardListDetailNavigationOption";
import DetailPrepaidHeader from "@/components/Contracts/Prepaids/DetailPrepaidHeader.vue";
import DetailPrepaidSummaries from "@/components/Contracts/Prepaids/DetailPrepaidSummaries.vue";
import DetailPrepaidTransactions from "@/components/Contracts/Prepaids/DetailPrepaidTransactions.vue";
import DetailPrepaidTransactionDetail from "@/components/Contracts/Prepaids/DetailPrepaidTransactionDetail.vue";

@Component({
  components: {
    BaseDetailCard,
    DetailPrepaidHeader,
    DetailPrepaidSummaries,
    DetailPrepaidTransactions,
    DetailPrepaidTransactionDetail,
  },
})
export default class ViewPrepaidsDetailCard extends Mixins(
  CardListDetailDetailCardMixin
) {
  navigationOptions = {
    name: "Details",
    navigationOptions: [
      {
        name: "Purchase Summaries",
      },
      {
        name: "Transactions",
        navigationOptions: [
          {
            name: "Transaction Detail",
            handleNavigationManually: true,
          },
        ],
      },
    ],
  } as CardListDetailNavigationOptions;
  selectedTransaction: PrepaidTransaction | null = null;
  selectedSummary: PrepaidPurchaseSummary | null = null;

  async selectedLayerChanged(): Promise<void> {
    if (this.selectedLayer === "Transactions") {
      await this.setPrepaidTransactions();
    }
    if (this.selectedLayer === "Purchase Summaries") {
      await this.setPrepaidSummaries();
    }
  }

  async setPrepaidTransactions(): Promise<void> {
    this.selectedTransaction = null;

    if (this.selectedItem.transactions) {
      if (this.selectedItem.transactions.length > 0) {
        this.selectedTransaction = this.selectedItem.transactions[0];
      }
      return;
    }

    this.loading = true;
    await getPrepaidTransactions(this.selectedItem.prepaidId)
      .then((response: PrepaidTransaction[]) => {
        this.selectedItem.transactions = response;

        if (this.selectedItem.transactions.length > 0) {
          this.selectedTransaction = this.selectedItem.transactions[0];
        }
      })
      .finally(() => (this.loading = false));
  }

  async setPrepaidSummaries(): Promise<void> {
    this.selectedTransaction = null;

    if (this.selectedItem.summaries) {
      if (this.selectedItem.summaries.length > 0) {
        this.selectedSummary = this.selectedItem.summaries[0];
      }
      return;
    }

    this.loading = true;
    await getPrepaidSummaries(this.selectedItem.prepaidId)
      .then((response: PrepaidPurchaseSummary[]) => {
        this.selectedItem.summaries = response;

        if (this.selectedItem.summaries.length > 0) {
          this.selectedSummary = this.selectedItem.summaries[0];
        }
      })
      .finally(() => (this.loading = false));
  }

  transactionSelected(item: PrepaidTransaction): void {
    this.selectedTransaction = item;
    this.moveToLayer("Transaction Detail");
  }

  summarySelected(item: PrepaidPurchaseSummary): void {
    this.selectedSummary = item;
    this.moveToLayer("Summary Detail");
  }

  get title() {
    return `${this.selectedPrepaid.prepaidId}`;
  }

  get selectedPrepaid(): Prepaid {
    return this.selectedItem as Prepaid;
  }

  get transactionDetailItems(): PrepaidTransaction[] {
    if (!this.selectedItem.transactions) return [];
    return this.selectedItem.transactions;
  }
}
